<template>
  <MountingPortal mountTo="#fourth">
    <div id="fourthslide" class="fourthslide" style="position: relative">
      <div class="heading">
        <div class="headingstyle">Projects</div>
        <div id="span"></div>
        <br />
        <div class="relative">
          <div class="my-auto heightit">
            <div class="text-center">
              <template v-for="(piece, index) in forlloop">
                <v-tooltip left :color="piece[0]" :key="index">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx2"
                      fab
                      dark
                      small
                      style="margin:10px"
                      :style="{ background: piece[0] }"
                      :color="piece[0]"
                      v-bind="attrs"
                      v-on="on"
                      @click="handler(piece[3])"
                    >
                      <i :class="piece[2]" style="font-size: 18px"></i>
                    </v-btn>
                  </template>
                  <span>{{ piece[3] }}</span>
                </v-tooltip>
              </template>
            </div>
          </div>
        </div>
        <v-row no-gutters style="justify-content: center">
          <template v-for="(tab, index) in tabs">
            <v-col
              cols="10"
              v-show="tab.category.includes(cat) || cat === ''"
              sm="3"
              :key="tab.thing"
              style="margin: 10px"
            >
              <a
                :href="tab.link"
                target="_blank"
                @mouseover="showit = true"
                style="text-decoration: none;font-family: 'Zen Antique Soft', serif;"
              >
                <v-card
                  class="cardinmob"
                  elevation="10"
                  shaped
                  outlined
                  data-aos="fade-up"
                >
                  <v-card-title class="flexinall">
                    <div style="font-family: 'Poppins'">{{ tab.thing }}</div>
                    <!-- <div style="font-family: 'Poppins'">{{ tab.link }}</div> -->
                    <img
                      :src="tab.fig"
                      alt="Image"
                      style="width: 100%; height: auto; margin-bottom: 2px"
                    />
                    <v-card-text :style="{ padding: 0, marginBottom: '10px' }">
                      {{ tab.description }}
                    </v-card-text>
                    <v-row :style="{ margin: 0 }" class="displayitre">
                      <template v-for="chip in tab.tech">
                        <v-chip
                          class="ma-2"
                          :style="{
                            background: colors[index % 7],
                            color: 'white',
                            margin: 2,
                          }"
                          style="margin: 2px"
                          text-color="white"
                          :key="chip"
                        >
                          {{ chip }}
                        </v-chip>
                      </template>
                    </v-row>
                  </v-card-title>
                </v-card>
              </a>
            </v-col>
          </template>
        </v-row>
      </div>
    </div>
  </MountingPortal>
</template>

<script>
import First from "./images/first.png";
import Second from "./images/second.png";
import Third from "./images/third.png";
import Fourth from "./images/fourth.png";
import Fifth from "./images/fifth.png";
import Sixth from "./images/Sixth.png";
import Seventh from "./images/Seventh.png";
import Eigth from "./images/Eighth.png";
import Ninth from "./images/Ninth.png";
import Tenth from "./images/Tenth.png";
import Twelth from "./images/Twelth.png";
import Thirteenth from "./images/Thirteenth.png";
import Eleventh from "./images/Eleventh.webp";
export default {
  data() {
    return {
      colors: [
        "#53B257",
        "#3F51B5",
        "#F44336",
        "#E91963",
        "#FF9800",
        "#009688",
        "#1867C0",
      ],
      cat: "",
      forlloop: [
        [
          "indigo",
          "TabC",
          "fab fa-bootstrap",
          "Frontend",
          // this.methods.handleFrontend,
        ],
        [
          "green",
          "TabD",
          "fab fa-node-js",
          "Backend",
          // this.methods.handleBackend,
        ],
        [
          "#001234",
          "TabE",
          "fas fa-globe",
          "Full stack",
          // this.methods.handleBackend,
        ],
        [
          "#4caf50",
          "TabB",
          "fab fa-python",
          "Python development",
          // this.methods.handlePythonDevelopment,
        ],
        [
          "#ff5252",
          "TabB",
          "fas fa-toolbox",
          "All projects",
          // this.methods.handlePythonDevelopment,
        ],
      ],
      tabs: [
        {
          thing: "Portfolio Website",
          description: "This is my portfolio website.",
          link: "/",
          tech: ["Vue2", "Vuetify"],
          fig: First,
          category: ["Frontend"],
        },
        {
          thing: "Elan & Nvision",
          description: "This is a website for cultural fest IITH 2022.",
          fig: Second,
          tech: ["React", "Tailwindcss"],
          link: "https://elan.org.in",
          category: ["Frontend"],
        },
        {
          thing: "CA Program Elan",
          description: "Campus Ambassdor program website.",
          link: "https://ca.elan.org.in",
          tech: ["EJS", "ExpressJs"],
          fig: Fourth,
          category: ["Full stack", "Backend", "Frontend"],
        },
        {
          thing: "Blog",
          description:
            "MERN Blog project with Firebase Google sign-in and Express.",
          link: "https://blog-frontend-eta-lyart.vercel.app/",
          fig: Thirteenth,
          tech: ["MERN", "Firebase"],
          category: ["Full stack", "Backend", "Frontend"],
        },
        {
          thing: "Student Helper",
          description:
            "A web-app that I done for MILAN to reduce mails for cab sharing, lost/found at IITH.",
          fig: Fifth,
          tech: ["Sheets API", "JS"],
          link: "https://devulapallisai.github.io/milan/",
          category: ["Frontend"],
        },
        {
          thing: "Todo App",
          description:
            "Simple MERN project with Json web token package in Express.",
          link: "https://todo-express-2022.netlify.app/",
          fig: Twelth,
          tech: ["MERN", "heroku"],
          category: ["Full stack", "Backend", "Frontend"],
        },
        {
          thing: "InstantNotetaker",
          description: "A PWA which serves as Notes app using localstorageAPI",
          link: "https://instantnotetaker.me",
          fig: Seventh,
          tech: ["JS", "LocalStorageAPI"],
          category: ["Frontend"],
        },
        {
          thing: "Elan Beta Website",
          description:
            "This is a temporary website for Elan cultural fest IITH 2022 for sponsors.",
          fig: Eigth,
          tech: ["AOS", "VantaJS"],
          link: "https://devulapallisai.github.io/Elan-Nvision/",
          category: ["Frontend"],
        },
        {
          thing: "Social Cause Elan",
          description:
            "Online portal against cyber harassment for Elan & nVision 2022.",
          fig: Third,
          tech: ["JS", "Sheets API"],
          link: "https://social-cause-elan22.netlify.app/",
          category: ["Frontend"],
        },

        {
          thing: "SWOT Generator",
          description:
            "A website takes data as input to a page which has some design so that you can have screenshot of that.",
          link: "https://devulapallisai.github.io/SWOT-Analysis-Generator/",
          fig: Sixth,
          tech: ["JS", "HTML5 & CSS"],
          category: ["Frontend"],
        },
        {
          thing: "Flappy bird",
          description:
            "A web browser flappy bird game clone using Javascript works  on laptop only",
          link: "https://devulapallisai.github.io/A-laptop-Flappy-Bird-Game/",
          fig: Ninth,
          tech: ["JS", "HTML5 & CSS"],
          category: ["Frontend"],
        },
        {
          thing: "Notepad Clone",
          description: "Windows Notepad clone using Python GUI library Tkinter",
          link: "https://github.com/devulapallisai/Own-Notepad-",
          fig: Tenth,
          tech: ["Tkinter", "Pywhatkit"],
          category: ["Python"],
        },
        {
          thing: "Desktop Assistant",
          description: "Fun project to explore and learn python modules.",
          link: "https://github.com/devulapallisai/Desktop-Assistant",
          fig: Eleventh,
          tech: ["Python modules"],
          category: ["Python"],
        },
      ],
    };
  },
  methods: {
    handler(e) {
      console.log("clicked", e, this.tabs);
      // this.tabs = this.tabs.filter((item) => item.category.length > 1);
      // console.log("clicked", e, this.tabs);
      if (e === "Full stack") {
        this.cat = "Full stack";
      } else if (e === "Frontend") {
        this.cat = "Frontend";
      } else if (e === "Backend") {
        this.cat = "Backend";
      } else if (e === "Python development") {
        this.cat = "Python";
      } else {
        this.cat = "";
      }
    },
  },
};
</script>

<style scoped>
.heightit {
  display: flex;
  flex-direction: column;
  width: 50px;
  /* top: 0; */
  position: sticky;
  margin: auto;
  justify-content: space-around;
  /* min-height: 300px; */
}
* {
  /* white-space: pre-wrap; */
  word-break: break-word;
}
@media screen and (max-width: 760px) {
  .cardinmob {
    max-width: 250px;
    margin: auto;
  }
}
.fourthslide {
  margin-left: 22vw;
  width: 78vw;
  margin-top: -0.8rem;
  background: linear-gradient(
    rgba(170, 236, 241, 0.726),
    rgba(127, 207, 249, 0.849),
    #29599ccf,
    #173a6ce2,
    #22487de6
  );
  min-height: 400px;
  /* overflow: hidden; */
}
.flexinall {
  display: flex;
  min-height: 100px;
  flex-direction: column;
  /* justify-content: space-between; */
  /* width: inherit; */
}
.relative {
  /* position: absolute; */
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  float: right;
  justify-content: center;
  width: 50px;
  margin-right: 10px;
  /* overflow: hidden; */
  /* height: 100vh; */
}
@media screen and (max-width: 600px) {
  .relative {
    display: none;
  }
}
#span {
  width: 6vw;
  padding-bottom: 1vh;
  margin-bottom: 2vh;
  margin: 0 2.2vw;
  border-bottom: 4px solid rgb(47, 65, 223);
}
@media screen and (max-width: 768px) and (max-height: 1025px) {
  .fourthslide {
    margin-left: 0vw;
    width: 100vw;
  }
  #span {
    width: 17vw;
    padding-bottom: 1vh;
    margin-bottom: 2vh;
    border-bottom: 4px solid rgb(47, 65, 223);
  }
}
.headingstyle {
  font-size: 2.8rem;
  margin: 0 2.2vw;
  /* margin-bottom: 20px; */
  font-family: "Zen Antique Soft", serif;
  color: #173b6c;
}
</style>
